module.exports = {
  siteMetadata: {
    title: 'Limitless With Jess',
    description: 'Gatsby starter for bootstrap a blog',
    siteUrl: 'https://limitlesswithjess.com/',
    author: 'ExpansionJS',
    twitter: 'ExpansionJS',
    adsense: '',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/content/posts/`,
        name: 'posts',
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/static/assets/img/`,
        name: 'img',
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          {
            resolve: 'gatsby-remark-images',
            options: {
              maxWidth: 750,
              linkImagesToOriginal: false,
              wrapperStyle: 'margin-bottom: 1.0725rem;',
            },
          },
          {
            resolve: 'gatsby-remark-responsive-iframe',
            options: {
              wrapperStyle: 'margin-bottom: 1.0725rem',
            },
          },
          'gatsby-remark-prismjs',
          'gatsby-remark-copy-linked-files',
          'gatsby-remark-smartypants',
        ],
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: 'Limitless With Jess',
        short_name: 'Limitless',
        description: 'Gatsby starter for bootstrap a blog',
        homepage_url: 'https://limitlesswithjess.com/',
        start_url: '/',
        background_color: '#fff',
        theme_color: '#08cc96',
        display: 'standalone',
        icons: [
          {
            src: '/img/android-chrome-192x192.png',
            sizes: '192x192',
            type: 'image/png',
          },
          {
            src: '/img/android-chrome-512x512.png',
            sizes: '512x512',
            type: 'image/png',
          },
        ],
      },
    },
    // {
    //   resolve: 'gatsby-plugin-google-analytics',
    //   options: {
    //     trackingId: '',
    //   },
    // },
    {
      resolve: `gatsby-source-contentful`,
      options: {
        spaceId: `1cqm61daqacf`,
        accessToken: `7fNQ45b8eJoAtB905Mg1odWIqpFkxzBJJ_ZU5_Ehyms`,
      },
    },
    'gatsby-plugin-catch-links',
    'gatsby-plugin-offline',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
    'gatsby-plugin-sitemap',
    'gatsby-plugin-twitter',
    'gatsby-transformer-sharp',
    {
      resolve: 'gatsby-plugin-netlify',
      options: {
        mergeSecurityHeaders: true,
        mergeLinkHeaders: true,
        mergeCachingHeaders: true,
      },
    },
    // {
    //   resolve: `gatsby-source-shopify`,
    //   options: {
    //     // The domain name of your Shopify shop.
    //     shopName: `limitless-with-jess`,
    //     // The storefront access token
    //     accessToken: `b28dbb512588a823e1b0871ed887239e`,
    //     verbose:true,
    //     paginationSize: 250,
    //   },
    // },
  ],
}
